export default "/images/5a8132e7b2929f9e3ab7d7b0c61982d0.avif";